const SmallGrid = ({ width }) => {
    return (
        <div className={`small-grid-icon ${width}`}>
                <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path fill="#414042" d="M0 0H4V4H0z"></path>
      <path fill="#414042" d="M0 6H4V10H0z"></path>
      <path fill="#414042" d="M0 12H4V16H0z"></path>
      <path fill="#414042" d="M6 0H10V4H6z"></path>
      <path fill="#414042" d="M6 6H10V10H6z"></path>
      <path fill="#414042" d="M6 12H10V16H6z"></path>
      <path fill="#414042" d="M12 0H16V4H12z"></path>
      <path fill="#414042" d="M12 6H16V10H12z"></path>
      <path fill="#414042" d="M12 12H16V16H12z"></path>
    </svg>
        </div>
    )
}

export default SmallGrid
